import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import appleFilled from '@iconify/icons-ant-design/team-outlined';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import { fNumber } from '../../../utils/formatNumber';
import { baseUrl } from '../../../utils/constants';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
    theme.palette.info.dark,
    0.24
  )} 100%)`
}));

const TOTAL = 0;

export default function AppNewUsers() {
  const group = Number(sessionStorage.getItem('province'));
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [dashSum, setDashSum] = useState({
    totalActive: 0,
    newMembers: 0,
    paymentsThisMonth: 0.0,
    failedDebitOrders: 0.0
  });

  useEffect(() => {
    getDashBoardSummaries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDashBoardSummaries = () => {
    fetch(`${baseUrl}/api/client/getDashBoardSummaries?provinceId=${group}`)
      .then((res) => res.json())
      .then(
        (result) => {
          setDashSum(result.result);
        },
        (error) => {
          notifyPopup(`Error in getDashBoardSummaries!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={appleFilled} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{fNumber(dashSum.totalActive)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Active Members
      </Typography>
    </RootStyle>
  );
}
